module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"focus accounts":"включить счета","exclude accounts":"исключить счета","All accounts":"Все счета"}}')
  delete Component.options._Ctor
}
